import { render, staticRenderFns } from "./NotableIndividualDetail.vue?vue&type=template&id=4b332642&scoped=true"
import script from "./NotableIndividualDetail.vue?vue&type=script&lang=js"
export * from "./NotableIndividualDetail.vue?vue&type=script&lang=js"
import style0 from "./NotableIndividualDetail.vue?vue&type=style&index=0&id=4b332642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b332642",
  null
  
)

export default component.exports